import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import genericHelpers from './generic-helpers';
import wasPriceType from '../_shelf-category/types/was-price-type';

const FLAGS = {
  1: {
    css: 'best_seller',
    text: 'Best Seller',
  },
  2: {
    css: 'clearance',
    text: 'Clearance',
  },
  4: {
    css: 'new',
    text: 'New',
  },
  8: {
    css: 'rollback',
    text: 'Rollback',
  },
  128: {
    css: 'secondary-flag foil-stamped',
    text: 'Real Foil Card',
  },
};

const ProductFlags = props => {
  function hasWasPrice() {
    const wasPrices = [].concat(props.was_price);

    return (wasPrices || []).filter(Boolean).some(wp =>
      genericHelpers.isWasPriceValid({
        was_price: wp,
        price: props.price,
      })
    );
  }

  const attributes = [];

  if (hasWasPrice()) attributes.push(FLAGS[8]);

  for (const mask in FLAGS) {
    if (props.flag & mask) {
      attributes.push(FLAGS[mask]);
    }
  }

  return (
    <span className="flags">
      {attributes.map(({ css, text }) => {
        return (
          <span
            className={classNames('flag', css, props.className)}
            key={`${css}-${text}`}>
            {text}
          </span>
        );
      })}
    </span>
  );
};

ProductFlags.propTypes = {
  price: PropTypes.number,
  was_price: PropTypes.oneOfType([
    wasPriceType,
    PropTypes.arrayOf(wasPriceType),
  ]),
  flag: PropTypes.number,
  className: PropTypes.string,
};

ProductFlags.defaultProps = {
  price: null,
  was_price: null,
  flag: null,
  className: null,
};

export default ProductFlags;
